export default __webpack_public_path__ + "static/2.1-241f49b73cf36ccb32f1743a9c9554d8.webp";